export const C_SYSTEM_RESOLUTION_TYPE = {
  '720px': 720,
  '1240px': 1240,
  default: 'default'
}

export const DEFAULT_LIMITED_TO_DISPLAY = 12
